// extracted by mini-css-extract-plugin
export default {"order_form":"OrderForm_order_form__mUA+G"};